(function () {
  var VIES_ENDPOINT = "https://vies-check.r-hemminga.workers.dev/check";
  // Helium field keys van het BTW-veld per shop: uviqs.com = vattax_id, technotape.com = tax_id.
  // Eén bestand voor beide shops; de key die op de pagina bestaat wordt gebruikt.
  var VAT_FIELD_KEYS = ["vattax_id", "tax_id"];
  var STATUS_FIELD_KEY = "vat_vies_status"; // optioneel verborgen Helium-veld

  var I18N = {
    nl: {
      invalid: "Dit BTW-nummer is niet geldig volgens VIES. Controleer het nummer (bijv. NL123456789B01).",
      valid: "BTW-nummer geldig",
      checking: "BTW-nummer controleren…",
      unavailable: "VIES is tijdelijk niet bereikbaar — we controleren uw nummer later handmatig.",
      required: "Vul uw BTW-nummer in.",
      uncheckable: "Dit nummer valt buiten de EU en wordt niet via VIES gecontroleerd.",
      registryFound: "Uw bedrijf is wel gevonden in het Franse handelsregister: {name}.",
      registryMissing: "Dit nummer is ook niet gevonden in het Franse handelsregister — controleer het goed.",
      retrying: "BTW-nummer controleren — VIES reageert traag, we blijven proberen (poging {n} van {m})…",
      nextTry: "volgende poging over {s} s…",
    },
    en: {
      invalid: "This VAT number is not valid according to VIES. Please check the number (e.g. NL123456789B01).",
      valid: "VAT number is valid",
      checking: "Checking VAT number…",
      unavailable: "VIES is temporarily unavailable — we will verify your number manually.",
      required: "Please enter your VAT number.",
      uncheckable: "This number is outside the EU and is not checked via VIES.",
      registryFound: "Your company was found in the French business register: {name}.",
      registryMissing: "This number was also not found in the French business register — please double-check it.",
      retrying: "Checking your VAT number — VIES is responding slowly, we keep trying (attempt {n} of {m})…",
      nextTry: "next attempt in {s} s…",
    },
    de: {
      invalid: "Diese USt-IdNr. ist laut VIES ungültig. Bitte überprüfen Sie die Nummer (z. B. DE123456789).",
      valid: "USt-IdNr. ist gültig",
      checking: "USt-IdNr. wird geprüft…",
      unavailable: "VIES ist vorübergehend nicht erreichbar — wir prüfen Ihre Nummer manuell.",
      required: "Bitte geben Sie Ihre USt-IdNr. ein.",
      uncheckable: "Diese Nummer liegt außerhalb der EU und wird nicht über VIES geprüft.",
      registryFound: "Ihr Unternehmen wurde im französischen Handelsregister gefunden: {name}.",
      registryMissing: "Diese Nummer wurde auch im französischen Handelsregister nicht gefunden — bitte prüfen Sie sie.",
      retrying: "USt-IdNr. wird geprüft — VIES antwortet langsam, wir versuchen es weiter (Versuch {n} von {m})…",
      nextTry: "nächster Versuch in {s} s…",
    },
    fr: {
      invalid: "Ce numéro de TVA n'est pas valide selon VIES. Veuillez vérifier le numéro.",
      valid: "Numéro de TVA valide",
      checking: "Vérification du numéro de TVA…",
      unavailable: "VIES est temporairement indisponible — nous vérifierons votre numéro manuellement.",
      required: "Veuillez saisir votre numéro de TVA.",
      uncheckable: "Ce numéro est hors UE et n'est pas vérifié via VIES.",
      registryFound: "Votre entreprise a été trouvée dans le registre français (SIRENE) : {name}.",
      registryMissing: "Ce numéro est également introuvable dans le registre français — veuillez le vérifier.",
      retrying: "Vérification du numéro de TVA — VIES répond lentement, nous réessayons (tentative {n} sur {m})…",
      nextTry: "prochaine tentative dans {s} s…",
    },
    es: {
      invalid: "Este número de IVA no es válido según VIES. Compruebe el número.",
      valid: "Número de IVA válido",
      checking: "Comprobando el número de IVA…",
      unavailable: "VIES no está disponible temporalmente — verificaremos su número manualmente.",
      required: "Introduzca su número de IVA.",
      uncheckable: "Este número está fuera de la UE y no se verifica mediante VIES.",
      registryFound: "Su empresa fue encontrada en el registro mercantil francés: {name}.",
      registryMissing: "Este número tampoco se encontró en el registro mercantil francés — compruébelo bien.",
      retrying: "Comprobando el número de IVA — VIES responde con lentitud, seguimos intentándolo (intento {n} de {m})…",
      nextTry: "próximo intento en {s} s…",
    },
  };
  var lang = (document.documentElement.lang || "en").slice(0, 2).toLowerCase();
  var T = I18N[lang] || I18N.en;

  // ── VIES-lookup met memo (zelfde nummer = één call) ──────────────
  var memo = {};
  var lastResult = null;

  // quick = achtergrondherkansing: de Worker doet dan één poging zonder eigen
  // herkansingen, want dit ís al een herkansing.
  function lookup(rawVat, quick) {
    var vat = (rawVat || "").toString().replace(/[\s.\-]/g, "").toUpperCase();
    if (!vat) return Promise.resolve(null);
    if (!memo[vat]) {
      memo[vat] = fetch(VIES_ENDPOINT + "?vat=" + encodeURIComponent(vat) + (quick ? "&quick=1" : ""))
        .then(function (r) { return r.json(); })
        .catch(function () { return { status: "unavailable", reason: "proxy_unreachable" }; })
        .then(function (res) {
          lastResult = res;
          // Diagnose in de console: zonder de reason is een verzadigde lidstaat
          // (MS_MAX_CONCURRENT_REQ) niet te onderscheiden van een echte storing.
          try {
            console.debug("[VIES]", vat, res && res.status,
              (res && res.reason) || "", "attempts=" + ((res && res.attempts) || "?"),
              (quick ? "(achtergrond)" : ""));
          } catch (e) {}
          // Alleen uitspraken onthouden. Een storing niet: de Worker heeft dan al
          // meerdere pogingen gedaan, maar bij submit mag hij het opnieuw proberen
          // i.p.v. de hele sessie op "handmatig" te blijven staan.
          if (res && res.status === "unavailable") delete memo[vat];
          return res;
        });
    }
    return memo[vat];
  }

  // ── Next-knop gate ───────────────────────────────────────────────
  // gate.status: empty | pending | checking | valid | invalid | unavailable
  var gate = { status: "empty" };

  function isVatInput(el) {
    if (!el || el.tagName !== "INPUT") return false;
    return VAT_FIELD_KEYS.indexOf(el.name) !== -1 ||
      VAT_FIELD_KEYS.indexOf(el.getAttribute("data-cf-field")) !== -1;
  }

  function findVatInput(formEl) {
    var inputs = formEl.querySelectorAll("input");
    for (var i = 0; i < inputs.length; i++) if (isVatInput(inputs[i])) return inputs[i];
    return null;
  }

  // Binnenlandse-handel-uitzonderingen: een VIES-"ongeldig" nummer blokkeert NIET bij
  //  - NL-prefix (binnenlandse verkoop, geen verlegde btw nodig), of
  //  - BE/FR/DE/IE-prefix mét het vinkje "I want to pay VAT as a small business"
  //    (kleine ondernemers staan niet in VIES: BE kleine onderneming,
  //     DE §19 Kleinunternehmer, FR franchise en base, IE onder de
  //     registratiedrempel — het Ierse btw-nummer is dan het tax reference
  //     number met IE-prefix, dat VIES als ongeldig meldt; CZ neplátce DPH
  //     onder de Tsjechische registratiedrempel, Raymon 29-09; CH onder de
  //     MWST-drempel van CHF 100.000, Raymon 04-11).
  // De check + melding blijven zichtbaar (waarschuwingskleur i.p.v. rood).
  var BE_CHECKBOX_KEY = "i_want_to_pay_vat_21_as_a_";
  var SMALL_BUSINESS_PREFIXES = ["BE", "FR", "DE", "IE", "CZ", "CH"];
  // Landen waar een kleine ondernemer helemaal GEEN btw-nummer heeft (CH: zonder
  // MWST-registratie is er alleen een UID, dat is geen btw-nummer). Land + vinkje
  // → het veld mag leeg blijven. Een wél ingevuld CHE-nummer valt buiten VIES en
  // gaat sowieso door (uncheckable). Zwitserland staat in VIES nooit.
  var NO_VAT_NUMBER_PREFIXES = ["CH"];

  // Land = Nederland (stap 1) → BTW-nummer mag leeg blijven. Het landveld zit in
  // stap 2 niet meer in de DOM → via cfForm.getFieldValue; select als fallback.
  // LET OP: het veld mag in Helium dan NIET meer op 'required' staan — dit script
  // neemt de verplicht-eis voor alle andere landen over.
  // Landwaarden per BTW-prefix: de bypass eist dat nummer én land hetzelfde land
  // aanwijzen, dus deze lijsten mogen NOOIT samengevoegd worden tot één lijst.
  var COUNTRY_VALUES = {
    NL: ["nl", "nld", "netherlands", "the netherlands", "nederland", "niederlande", "pays-bas", "países bajos", "paises bajos"],
    BE: ["be", "bel", "belgium", "belgië", "belgie", "belgien", "belgique", "bélgica", "belgica"],
    FR: ["fr", "fra", "france", "frankrijk", "frankreich", "francia", "frança", "franca"],
    DE: ["de", "deu", "ger", "germany", "duitsland", "deutschland", "allemagne", "alemania", "alemanha", "germania"],
    IE: ["ie", "irl", "ireland", "ierland", "irland", "irlande", "irlanda", "éire", "eire"],
    CZ: ["cz", "cze", "czechia", "czech republic", "the czech republic", "tsjechië", "tsjechie", "tsjechische republiek",
         "tschechien", "tschechische republik", "tchéquie", "tchequie", "république tchèque", "republique tcheque",
         "chequia", "república checa", "republica checa", "repubblica ceca", "cechia", "česko", "cesko",
         "česká republika", "ceska republika"],
    CH: ["ch", "che", "switzerland", "zwitserland", "schweiz", "suisse", "svizzera", "svizra", "suiza", "suíça", "suica",
         "swiss confederation", "schweizerische eidgenossenschaft", "confédération suisse", "confederation suisse",
         "confederazione svizzera"]
  };
  function countryValue(formEl) {
    var v = "";
    try {
      if (formEl.cfForm && typeof formEl.cfForm.getFieldValue === "function") {
        v = String(formEl.cfForm.getFieldValue("default_address.country") || "");
      }
    } catch (e) {}
    if (!v) {
      var sel = formEl.querySelector('select[name="default_address.country"]');
      if (sel) v = String(sel.value || "");
    }
    return v.trim().toLowerCase();
  }
  function countryMatches(formEl, prefix) {
    var list = COUNTRY_VALUES[prefix];
    return !!list && list.indexOf(countryValue(formEl)) !== -1;
  }
  function countryIsNL(formEl) {
    return countryMatches(formEl, "NL");
  }
  function smallBusinessChecked(formEl) {
    var cb = formEl.querySelector('input[type="checkbox"][name="' + BE_CHECKBOX_KEY + '"]');
    return !!(cb && cb.checked);
  }
  // Leeg BTW-veld mag door bij: land = Nederland (binnenlands), of land zonder
  // btw-nummer voor kleine ondernemers (CH) mét het vinkje. Alle andere landen
  // blijven verplicht (Raymon 06-08: "altijd verplichte invoer").
  function emptyAllowed(formEl) {
    if (countryIsNL(formEl)) return true;
    for (var i = 0; i < NO_VAT_NUMBER_PREFIXES.length; i++) {
      if (countryMatches(formEl, NO_VAT_NUMBER_PREFIXES[i])) return smallBusinessChecked(formEl);
    }
    return false;
  }

  function vatPrefix(value) {
    return String(value || "").trim().toUpperCase().replace(/[\s.\-]/g, "").slice(0, 2);
  }

  // Zelfde EU-lijst als de Cloudflare Worker (VIES-landen; GR = alias voor EL).
  // Nummer met een prefix buiten deze lijst (VS, CH, VK, ...) is niet via VIES
  // te controleren → knop NOOIT blokkeren, neutrale melding.
  var VIES_PREFIXES = ["AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "EL", "GR", "ES", "FI", "FR", "HR", "HU", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "RO", "SE", "SI", "SK", "XI"];
  function isViesNumber(value) {
    return VIES_PREFIXES.indexOf(vatPrefix(value)) !== -1;
  }
  // Bypass geldt alleen als het NUMMER én het gekozen LAND (stap 1) hetzelfde
  // land aanwijzen — anders kun je met één ongeldig nummer + vinkje van land
  // wisselen en zo de controle omzeilen.
  function domesticBypass(formEl, vatValue) {
    var p = vatPrefix(vatValue);
    if (!countryMatches(formEl, p)) return false;
    if (p === "NL") return true; // binnenlands, geen vinkje nodig
    if (SMALL_BUSINESS_PREFIXES.indexOf(p) === -1) return false;
    return smallBusinessChecked(formEl);
  }

  // LET OP: nooit btn.disabled zetten — Helium beheert dat attribuut zelf en
  // draait het terug; daartegen vechten gaf een mutation-loop die de pagina
  // bevroor. De klik wordt geblokkeerd door de click-guard (capture-fase);
  // dit is alleen de visuele indicatie. Alleen schrijven bij echt verschil.
  function applyGate(formEl) {
    var btn = formEl.querySelector("button.cf-next-step");
    if (!btn) return;
    var input = findVatInput(formEl);
    var ok = !input || gate.status === "valid" || gate.status === "unavailable" ||
      gate.status === "uncheckable" || // buiten EU → nooit blokkeren
      (gate.status === "invalid" && domesticBypass(formEl, input.value)) ||
      (gate.status === "empty" && emptyAllowed(formEl)); // NL / CH+vinkje mag leeg laten
    var opacity = ok ? "" : "0.5";
    var cursor = ok ? "" : "not-allowed";
    if (btn.style.opacity !== opacity) btn.style.opacity = opacity;
    if (btn.style.cursor !== cursor) btn.style.cursor = cursor;
    var aria = btn.getAttribute("aria-disabled") === "true";
    if (ok && aria) btn.removeAttribute("aria-disabled");
    if (!ok && !aria) btn.setAttribute("aria-disabled", "true");
  }

  function setGate(formEl, status) {
    gate.status = status;
    applyGate(formEl);
  }

  // ── Inline feedback onder het veld ───────────────────────────────
  function statusEl(input) {
    var el = input.parentNode.querySelector(".vies-inline-status");
    if (!el) {
      el = document.createElement("div");
      el.className = "vies-inline-status";
      el.style.cssText = "margin-top:6px;font-size:0.85em;line-height:1.4;";
      input.parentNode.appendChild(el);
    }
    return el;
  }

  function showStatus(input, kind, text) {
    var el = statusEl(input);
    var colors = { ok: "#108043", error: "#d72c0d", warn: "#b45309", info: "#6d7175" };
    el.style.color = colors[kind] || colors.info;
    el.textContent = text || "";
  }

  // Herkansing zolang VIES niet bereikbaar is. Sommige lidstaten (gemeten: FR)
  // zitten in bursts vol en antwoorden pas seconden later. Zolang de herkansingen
  // lopen blijft de Next-knop DICHT en ziet de klant een poging-teller met
  // aftelklok (besluit Raymon 18-08: pas verder na de laatste uitspraak; alleen
  // als óók de laatste herkansing geen uitspraak geeft, gaat de knop alsnog open).
  var RECHECK_INTERVAL_MS = 10000;
  var RECHECK_MAX = 6; // 1 + 6 pogingen = ca. één minuut
  var recheckTimer = null;
  var recheckCount = 0;

  function stopRecheck() {
    clearTimeout(recheckTimer);
    recheckTimer = null;
  }

  // Aftelklok tussen twee herkansingen — laat zien dat er gewerkt wordt.
  var tickerTimer = null;

  function stopTicker() {
    clearInterval(tickerTimer);
    tickerTimer = null;
  }

  function registrySuffix(res) {
    if (!res || !res.registry) return "";
    if (res.registry.found === true) return " " + T.registryFound.replace("{name}", res.registry.name || "");
    if (res.registry.found === false) return " " + T.registryMissing;
    return "";
  }

  function showRetryProgress(input, res) {
    stopTicker();
    var base = T.retrying
      .replace("{n}", String(recheckCount + 1))
      .replace("{m}", String(RECHECK_MAX + 1)) + registrySuffix(res);
    showStatus(input, "info", base);
    var next = Date.now() + RECHECK_INTERVAL_MS;
    tickerTimer = setInterval(function () {
      if (!document.body.contains(input)) { stopTicker(); return; }
      var s = Math.max(0, Math.ceil((next - Date.now()) / 1000));
      showStatus(input, "info", base + " " + T.nextTry.replace("{s}", String(s)));
    }, 1000);
  }

  function scheduleRecheck(input, formEl, vat) {
    stopRecheck();
    if (recheckCount >= RECHECK_MAX) return;
    recheckTimer = setTimeout(function () {
      if ((input.value || "").trim() !== vat) return;      // waarde intussen gewijzigd
      if (!document.body.contains(input)) return;          // veld weg (andere stap)
      recheckCount++;
      liveCheck(input, formEl, true);
    }, RECHECK_INTERVAL_MS);
  }

  // quiet = achtergrondherkansing: melding en gate blijven staan tot er een
  // uitspraak is, dus geen knipperende "controleren…" tijdens het invullen.
  function liveCheck(input, formEl, quiet) {
    var vat = (input.value || "").trim();
    if (!quiet) { stopRecheck(); stopTicker(); }
    if (!vat) {
      stopTicker();
      showStatus(input, "info", "");
      setGate(formEl, "empty");
      return;
    }
    if (!isViesNumber(vat)) {
      stopTicker();
      showStatus(input, "info", T.uncheckable);
      setGate(formEl, "uncheckable"); // buiten EU → nooit blokkeren, geen VIES-call
      return;
    }
    if (!quiet) {
      showStatus(input, "info", T.checking);
      setGate(formEl, "checking");
    }
    lookup(vat, quiet).then(function (res) {
      if ((input.value || "").trim() !== vat) return; // waarde intussen gewijzigd
      if (!res) { stopTicker(); showStatus(input, "info", ""); setGate(formEl, "empty"); return; }
      if (res.status === "invalid") {
        stopTicker();
        var bypass = domesticBypass(formEl, input.value);
        showStatus(input, bypass ? "warn" : "error", "✗ " + T.invalid);
        setGate(formEl, "invalid");
      } else if (res.status === "valid") {
        stopTicker();
        showStatus(input, "ok", "✓ " + (res.name && res.name !== "---" ? res.name : T.valid));
        setGate(formEl, "valid");
      } else if (recheckCount < RECHECK_MAX) {
        // Nog herkansingen over: knop blijft dicht, zichtbare voortgang met
        // poging-teller + aftelklok (klant mag niet denken dat de boel vastzit).
        showRetryProgress(input, res);
        setGate(formEl, "retrying");
        scheduleRecheck(input, formEl, vat);
      } else {
        // Laatste herkansing gaf óók geen uitspraak → nu pas fail-open, met
        // status-stempel voor handmatige controle. FR-registeruitslag erbij.
        stopTicker();
        var kind = (res.registry && res.registry.found === false) ? "warn" : "info";
        showStatus(input, kind, T.unavailable + registrySuffix(res));
        setGate(formEl, "unavailable");
      }
    });
  }

  // ── Status-stempel richting Helium (optioneel verborgen veld) ────
  // Helium kent geen hidden-veldtype: vat_vies_status staat als gewoon
  // single-line-textveld in het formulier en wordt hier verborgen zodat de
  // klant het nooit ziet. Alleen schrijven bij echt verschil (geen
  // mutation-ping-pong met Helium's renderer).
  function hideStatusField(formEl) {
    var sel = 'input[name="' + STATUS_FIELD_KEY + '"], input[data-cf-field="' + STATUS_FIELD_KEY + '"]';
    var inputs = formEl.querySelectorAll(sel);
    for (var i = 0; i < inputs.length; i++) {
      var wrap = (inputs[i].closest && inputs[i].closest("div")) || inputs[i];
      if (wrap.style.display !== "none") wrap.style.display = "none";
    }
  }

  function stampStatus(cfForm) {
    if (!lastResult) return;
    try {
      var stamp = lastResult.status +
        " @ " + new Date().toISOString() +
        (lastResult.name ? " | " + lastResult.name : "") +
        (lastResult.consultationNumber ? " | VIES#" + lastResult.consultationNumber : "");
      // FR-fallback van de Worker: als VIES geen uitspraak gaf reist de uitslag
      // van het Franse handelsregister (SIRENE) mee — in hetzelfde stempel, zodat
      // de beoordelaar bij "unavailable" meteen ziet of het bedrijf echt bestaat.
      var reg = lastResult.registry;
      if (reg) {
        var sirenTag = reg.siren ? "SIREN " + reg.siren + " " : "";
        if (reg.found === true) {
          stamp += " | FR-register: " + sirenTag + (reg.name || "gevonden") + (reg.active ? " (actief)" : " (NIET actief)");
        } else if (reg.found === false) {
          stamp += " | FR-register: " + sirenTag + "niet gevonden";
        }
      }
      if (typeof cfForm.setFieldValue === "function") {
        cfForm.setFieldValue(STATUS_FIELD_KEY, stamp);
      }
    } catch (e) { /* status-stempel mag nooit de submit breken */ }
  }

  function attach(formEl) {
    var cfForm = formEl.cfForm;
    if (!cfForm || cfForm.__viesAttached) return;
    cfForm.__viesAttached = true;

    var debounceTimer = null;

    // 1) Live check: tijdens typen (debounce, zodra het op een BTW-nummer lijkt)
    //    en bij het verlaten van het veld. Delegatie omdat het veld pas in een
    //    latere stap gerenderd wordt (blur bubbelt niet, focusout wel).
    formEl.addEventListener("focusout", function (e) {
      if (!isVatInput(e.target)) return;
      clearTimeout(debounceTimer);
      liveCheck(e.target, formEl);
    });
    formEl.addEventListener("input", function (e) {
      if (!isVatInput(e.target)) return;
      var input = e.target;
      var el = input.parentNode.querySelector(".vies-inline-status");
      if (el) el.textContent = ""; // oude uitslag weg bij typen
      var v = (input.value || "").trim();
      setGate(formEl, v ? "pending" : "empty");
      recheckCount = 0; // ander nummer → weer een volle ronde herkansingen waard
      stopRecheck();
      stopTicker();
      clearTimeout(debounceTimer);
      if (/^[A-Za-z]{2}[0-9A-Za-z+*.\s]{2,14}$/.test(v)) {
        debounceTimer = setTimeout(function () { liveCheck(input, formEl); }, 700);
      }
    });

    // BE-vinkje aan/uit → gate en meldingskleur direct bijwerken (memo = geen extra call)
    formEl.addEventListener("change", function (e) {
      if (!e.target || e.target.type !== "checkbox") return;
      var input = findVatInput(formEl);
      if (input && gate.status === "invalid") liveCheck(input, formEl);
      else applyGate(formEl);
    });

    // 2) Multi-step: als het BTW-veld (opnieuw) verschijnt, gate direct goed zetten
    //    en een al ingevulde waarde meteen checken (memo maakt dat gratis).
    //    Bewust ALLEEN childList (geen attributes): attributen observeren gaf
    //    een ping-pong-loop met Helium's eigen renderer → bevroren pagina.
    var mo = new MutationObserver(function () {
      var input = findVatInput(formEl);
      if (input && !input.__viesSeen) {
        input.__viesSeen = true;
        if ((input.value || "").trim()) liveCheck(input, formEl);
        else setGate(formEl, "empty");
      }
      hideStatusField(formEl);
      applyGate(formEl);
    });
    mo.observe(formEl, { childList: true, subtree: true });
    hideStatusField(formEl);
    applyGate(formEl);

    // 2b) Click-guard als extra slot: mocht de knop toch even actief zijn
    //     (race met Helium's re-render), dan blokkeert de klik zelf alsnog.
    //     Leeg veld laten we door — dan toont Helium zijn eigen 'verplicht'-melding.
    formEl.addEventListener("click", function (e) {
      var btn = e.target && e.target.closest ? e.target.closest("button.cf-next-step") : null;
      if (!btn) return;
      var input = findVatInput(formEl);
      if (!input) return; // BTW-veld niet in deze stap
      if (gate.status === "valid" || gate.status === "unavailable" || gate.status === "uncheckable") return;
      if (gate.status === "invalid" && domesticBypass(formEl, input.value)) return; // NL / BE+vinkje
      if (gate.status === "empty" && emptyAllowed(formEl)) return; // NL / CH+vinkje mag leeg laten
      e.preventDefault();
      e.stopPropagation();
      if (gate.status === "empty") showStatus(input, "error", "✗ " + T.required);
      else if (gate.status === "invalid") showStatus(input, "error", "✗ " + T.invalid);
      else if (gate.status === "retrying") { /* herkansingen lopen al; voortgang staat onder het veld */ }
      else liveCheck(input, formEl); // pending: check nu meteen
    }, true);

    // 3) Harde blokkade bij submit (hergebruikt memo, dus geen extra call).
    //    Per shop bestaat maar één van de keys; onbekende key mag nooit breken.
    VAT_FIELD_KEYS.forEach(function (key) {
      try {
        // Verplicht voor iedereen behalve NL-klanten en CH-kleine-ondernemers met
        // vinkje (veld in Helium op níet-verplicht)
        cfForm.addValidator({
          comparator: function (value) {
            var vat = (value || "").toString().trim();
            return vat ? true : emptyAllowed(formEl);
          },
          errorMessage: T.required,
        }, key);
        cfForm.addValidator({
          comparator: function (value) {
            var vat = (value || "").toString().trim();
            if (!vat) return Promise.resolve(true); // leeg wordt door de required-validator afgehandeld
            if (!isViesNumber(vat)) return Promise.resolve(true); // buiten EU → niet via VIES te checken
            return lookup(vat).then(function (res) {
              if (!res || res.status !== "invalid") return true; // alleen expliciet ongeldig blokkeert
              return domesticBypass(formEl, vat); // NL-prefix / BE-prefix+vinkje mag toch door
            });
          },
          errorMessage: T.invalid,
          async: true,
        }, key);
      } catch (e) { /* key bestaat niet in deze shop */ }
    });

    if (typeof cfForm.beforeSave === "function") {
      cfForm.beforeSave(function () { stampStatus(cfForm); });
    }
  }

  function init() {
    document.querySelectorAll("form[data-cf-form]").forEach(attach);
  }

  if (window.CF && typeof window.CF.ready === "function") {
    window.CF.ready(init);
  } else {
    // CF-object nog niet geladen; even wachten tot Helium er is
    var tries = 0;
    var timer = setInterval(function () {
      if (window.CF && typeof window.CF.ready === "function") {
        clearInterval(timer);
        window.CF.ready(init);
      } else if (++tries > 50) {
        clearInterval(timer);
      }
    }, 200);
  }
})();
